import { configureStore } from '@reduxjs/toolkit';
import uiReducer from '../features/uiSlice';
import authReducer from '../features/authSlice';
import { materialsApi } from '../services/materialsApi';
import { bookmarksApi } from '../services/bookmarksApi';
import { historyApi } from '../services/historyApi';
import { xpApi } from '../services/xpApi';
import { watchTimeApi } from '../services/watchTimeApi';
import { leaderboardApi } from '../services/leaderboardApi';
import { itemsApi } from '../services/itemsApi';
import { userApi } from '../services/userApi';

export const store = configureStore({
  reducer: {
    ui: uiReducer,
    auth: authReducer,
    [materialsApi.reducerPath]: materialsApi.reducer,
    [bookmarksApi.reducerPath]: bookmarksApi.reducer,
    [historyApi.reducerPath]: historyApi.reducer,
    [xpApi.reducerPath]: xpApi.reducer,
    [watchTimeApi.reducerPath]: watchTimeApi.reducer,
    [leaderboardApi.reducerPath]: leaderboardApi.reducer,
    [itemsApi.reducerPath]: itemsApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(materialsApi.middleware)
      .concat(bookmarksApi.middleware)
      .concat(historyApi.middleware)
      .concat(xpApi.middleware)
      .concat(watchTimeApi.middleware)
      .concat(leaderboardApi.middleware)
      .concat(itemsApi.middleware)
      .concat(userApi.middleware),
});

export default store;
